/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="agreement-checkout">
    <!-- terms and condition -->
    <b-form-group>
      <base-check-box
        name="term-marketing"
        v-model="marketingTerm"
        v-validate="'required:true'"
        :label="labelLinkPrivacy"
      />
    </b-form-group>
    <b-modal
      size="xl"
      v-model="ModalTermsShow"
      hide-footer>
      <div v-html="ModalTermsContent"/>
    </b-modal>
  </div>
</template>

<script>
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'

export default {
  inject: ['$validator'],
  name: 'AgreementsSection',
  components: {
    BaseCheckBox
  },
  data () {
    return {
      termsValue: {},
      marketingTerm: false,
      ModalTermsShow: false,
      ModalTermsContent: ''
    }
  },
  computed: {
    labelLinkPrivacy () {
      let linkPrivacy = 'https://www.coin.it/on/demandware.static/-/Sites/default/dwe713f2c7/informativa_acquisti_link2.pdf'
      return this.$t('register-page.terms-privacy', { linkPrivacy })
    }
  },
  methods: {
    openModal (term) {
      this.ModalTermsContent = term.content
      this.ModalTermsShow = true
    },
    validate () {
      return this.$validator.validate()
    }
  }
}
</script>
